import ActivityDetails from "./Chapters/Activities_Details";
import LatestStories from "./Chapters/Latest_stories";

import "./Css/Chapters.css";

function Chapters() {
  return (
    <div>
      <ActivityDetails />
      <LatestStories />
    </div>
  );
}

export default Chapters;
